(function ($, d, w) {

    let _w = $(w);

    _w.on(w.ZP_LOAD, onInit);

    function onInit() {
        const elements = $('.zp_svg_animator');
        if (elements.length > 0) {
            elements.each((index, element) => {
                new SVGAnimator($(element));
            });
        }
    }

    class SVGAnimator {

        constructor(root) {

            this.root = root;

            this.animation = null;
            this.animationElement = this.root.find('.bodymovin')[0];
            this.animationWasPlayed = false;

            this.jsonFile = this.root.attr('data-json');
            this.playOn = this.root.attr('data-play-on');
            this.loop = (parseInt(this.root.attr('data-loop')) === 1);

            this.init();

        }

        init() {

            this.animation = bodymovin.loadAnimation({
                container: this.animationElement,
                renderer: 'svg',
                loop: this.loop,
                autoplay: (this.playOn === 'load'),
                path: this.jsonFile
            });

            if (this.playOn === 'load') {
                this.animationWasPlayed = true;
            }

            //TODO: Am Anfang ist die Box 0px hoch
            setTimeout(()=> {

                //im Viewport
                if (this.playOn === 'view') {

                    this.playAnimation();

                    _w.on('scroll', () => {
                        this.playAnimation();

                    });
                    _w.on('resize', () => {
                        this.playAnimation();

                    });

                }

                //Bei Klick
                if (this.playOn === 'click') {
                    $(this.animationElement).on('click', () => {
                        if (!this.animationWasPlayed) {
                            this.playAnimation();
                        }
                    });

                }

                //Während des Scrollens
                if (this.playOn === 'scroll') {

                    this.scrollAnimationDelay = parseFloat(this.root.attr('data-scroll-animation-delay'));
                    this.scrollAnimationMultiplicator = parseFloat(this.root.attr('data-scroll-animation-multiplicator'));

                    this.animationOnScroll.bind(this);

                    _w.on('scroll', this.animationOnScroll.bind(this));

                    _w.on('resize', this.animationOnScroll.bind(this));

                }
            }, 100);

        }

        playAnimation () {
            if (this.isAnimationInView() && !this.animationWasPlayed) {
                this.animationWasPlayed = true;
                this.animation.play();
            }

        }

        isAnimationInView () {

            const rect = this.animationElement.getBoundingClientRect();
            // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
            const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
            const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

            // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
            // const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0); //Ist immer true, wenn Element im Viewport ist
            const vertInView = (rect.top <= windowHeight - (rect.height/2)) && ((rect.top + rect.height/2) >= 0); // ist immer true, wenn sich Element zur Hälfte im Viewport befindet
            // const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0); //Ist immer true, wenn Element im Viewport ist
            const horInView = (rect.left <= windowWidth - (rect.width/2)) && ((rect.left + rect.width/2) >= 0); //Ist immer true, wenn Element im Viewport ist

            return (vertInView && horInView);

        }

        animationOnScroll () {
            const rect = this.animationElement.getBoundingClientRect();
            const rectTop = rect.top-this.scrollAnimationDelay;

            const rectHeight = rect.height;
            const animationLength = this.animation.frameRate * this.animation.totalFrames;
            const framesPerScroll = animationLength / rectHeight;

            //Viewport unter Animationsleinwand
            if (rectTop <= 0) {

                //Schleife ist aktiviert
                if (this.loop) {
                    this.animation.goToAndStop(Math.abs(rectTop)*framesPerScroll*this.scrollAnimationMultiplicator % animationLength);
                }
                //Schleife ist deaktiviert
                else {
                    this.animation.goToAndStop(Math.abs(rectTop)*framesPerScroll*this.scrollAnimationMultiplicator);
                }

                if (this.animation.currentFrame >= this.animation.totalFrames) {
                    this.animation.goToAndStop(animationLength);
                }
            }
            else {
                this.animation.goToAndStop(0);
            }
        }

    }

})(jQuery, document, window);